export default "__VITE_ASSET__OueohVAW__"